import styled, {css} from "styled-components";
export const BusinnesWrap = styled.div`
    ${({$padding}) =>
        !$padding &&
        css`
            padding-bottom: 100px;
        `}
    .stepper-container {
        margin: 0 auto 20px;
        .btn {
            margin: 0 auto 40px 0;
            display: flex;
            align-items: center;
            min-width: 87px;
            padding: 9px 5px;
            &:hover {
                background: ${({theme}) => theme?.light?.primary};
                color: var(--white);
            }
        }
    }
    .questions {
        max-width: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }
    .upload-wrap {
        .label {
            display: block;
        }
        .label-title {
            display: block;
            margin-bottom: 12px;
            font-size: 18px;
            line-height: 22px;
            font-weight: 500;
        }
        .size-desc {
            display: block;
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            color: rgba(143, 143, 143, 1);
        }
        .labelButton {
            background-color: var(--white);
            border: 1px dashed rgba(205, 205, 205, 1);
            .icon-img {
                width: 35px;
            }
            .text-lg {
                color: rgba(143, 143, 143, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 300;
                margin-bottom: 16px;
            }
            .text {
                width: max-content;
                border: 1px solid rgba(225, 228, 232, 1);
                color: var(--text-color);
                border-radius: 60px;
                padding: 10px 25px;
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
        }
    }
    .stepper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 30px;
        overflow: hidden;
    }
    .step {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--gray-150);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
        position: relative;
    }
    .step.active {
        background-color: ${({theme}) => theme?.light?.primary};
    }
    .step::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 100%;
        width: 100px;
        height: 2px;
        background-color: #e0e0e0;
        transform: translateY(-50%);
    }
    .step.current::before {
        background-color: ${({theme}) => theme?.light?.primary};
    }

    .step:last-child::before {
        content: none;
    }
    .content {
        margin-bottom: 20px;
    }
    .step-content {
        font-size: 16px;
        color: #333;
    }
    /* .navigation button {
    padding: 10px 20px;
    margin: 0 5px;
    background-color: #ff6600;
    color: #fff;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }

  .navigation button[disabled] {
    background-color: #ccc;
    cursor: not-allowed;
  } */
`;
